import React, { useState, useEffect } from "react";
import ProductCard from "./ProductCard";
import { useHttpClient } from "./hooks/http-hook";
import LoadingSpinner from "./LoadingSpinner/LoadingSpinner";

const ProductList = () => {
  const [allProducts, setAllProducts] = useState();
  const { error, sendRequest, clearError, isLoading } = useHttpClient();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const responseData = await sendRequest(
          process.env.REACT_APP_PRODUCTS
        );
        setAllProducts(responseData.products);
      } catch (err) {}
    };
    fetchProducts();
  }, [sendRequest]);
  return (
    <div className="container py-5">
      <div className="row">
        {isLoading && (
          <div style={{ width: "100px", margin: "0 auto" }}>
            <LoadingSpinner />
          </div>
        )}
        {!isLoading &&
          allProducts &&
          allProducts.map((product) => {
            return (
              <ProductCard
                key={product._id.toString()}
                image={product.image}
                price={product.price}
                title={product.title}
                id={product._id.toString()}
                inStock={product.inStock}
                inCart={product.inCart}
              />
            );
          })}
      </div>
    </div>
  );
};

export default ProductList;
